// dependencies
import React from "react";
import { useIntl } from "react-intl";
import { View, StyleSheet, TextStyle } from "react-native";

// components
import BaseComponent from "../BaseComponent";
import Rate from "../Rate";
import Stack from "../Stack";
import Text from "../Text";
import { List, ListItem } from "../List";
import RateList from "./RateList";

type PropsType = {
  averageRate: number;
  cosinessRate: number;
  fairnessRate: number;
  greetingRate: number;
  qualityRate: number;
  title: string;
  content: string;
};

const styles = StyleSheet.create({
  detailsContainer: {
    height: "100%",
  },
  details: {
    justifyContent: "center",
  },
  titleView: {
    justifyContent: "center",
    height: "100%",
  },
  title: {
    fontSize: "1.125em" as any,
  },
  content: {
    fontSize: "0.875em" as any,
  },
  quote: {
    userSelect: "none",
  } as TextStyle,
  listItem: {
    flexShrink: 1,
  },
});

const Details: React.FunctionComponent<PropsType> = (props) => {
  const {
    averageRate,
    cosinessRate,
    fairnessRate,
    greetingRate,
    qualityRate,
    title,
    content,
  } = props;

  const intl = useIntl();

  return (
    <BaseComponent
      containerStyle={styles.detailsContainer}
      childrenStyle={styles.details}
    >
      <List gutter={0.625} inline={true}>
        <ListItem>
          <Rate rate={averageRate} />
        </ListItem>

        <ListItem style={styles.listItem}>
          <View style={styles.titleView}>
            <Text style={styles.title}>
              <Text
                style={styles.quote}
                accessible={false}
                importantForAccessibility="no-hide-descendants"
              >
                {intl.formatMessage({
                  defaultMessage: "«",
                })}
                {"\u202f"}
              </Text>
              {title}
              <Text
                style={styles.quote}
                accessible={false}
                importantForAccessibility="no-hide-descendants"
              >
                {"\u202f"}
                {intl.formatMessage({
                  defaultMessage: "»",
                })}
              </Text>
            </Text>
          </View>
        </ListItem>
      </List>
      <Stack marginTop={0.625} />
      <Text style={styles.content}>{content}</Text>
      <Stack marginTop={0.625} />
      <RateList
        cosinessRate={cosinessRate}
        fairnessRate={fairnessRate}
        greetingRate={greetingRate}
        qualityRate={qualityRate}
      />
    </BaseComponent>
  );
};

export default Details;
